import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // GÜNCELLENEN KISIM:
      // - w-11 h-6: Boyutlar standartlaştırıldı.
      // - bg-slate-200 dark:bg-slate-700: Kapalıyken gri/koyu gri zemin.
      // - data-[state=checked]:bg-[#E65100]: Açıkken TURUNCU (Marka Rengi).
      // - border-2 border-transparent: Dış hatları temizlemek için.
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#E65100] data-[state=unchecked]:bg-slate-200 dark:data-[state=unchecked]:bg-slate-700",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        // Yuvarlak düğmenin hareketi
        "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }